import {
  useState,
} from 'react';
import styled from 'styled-components';

import { MatchedTargets } from '@/core/interfaces/common';

const GreetingText = styled.h3`
  font-size: 16px;
  line-height: 28px;
`;

const ShowMoreButton = styled.button`
  margin-left: 2px;
  outline: inherit;
  border: none;
  border-bottom: 2px dotted #000;
  padding: 0 0 1px;
  background: none;
  color: inherit;
  font-size: inherit;
  cursor: pointer;
`;

interface GreetingProps {
  isEmailAction: boolean;
  targets: MatchedTargets;
  mode: string;
}

export const Greeting = ({
  isEmailAction,
  targets,
  mode,
}: GreetingProps) => {
  const [
    showRestOfOfficials,
    setShowRestOfOfficials,
  ] = useState(false);

  let greeting = 'Dear';

  if (isEmailAction && mode === 'petition') {
    greeting = 'To the Attention of:';
  } else if (!isEmailAction) {
    greeting = 'You will be connected to';
  }

  if (!targets.length) {
    if (isEmailAction && mode === 'petition') {
      return (
        <GreetingText>
          To the Attention of (addressees will be added):
        </GreetingText>
      );
    }

    if (isEmailAction) {
      return (
        <GreetingText>
          Dear Office Holder (names will be automatically added on each email),
        </GreetingText>
      );
    }

    return (
      <GreetingText>
        You will be connected to your matched officials after you click Call.
      </GreetingText>
    );
  }
  const isMoreThanThreeOfficials = targets.length > 3;
  const shownTargets = !showRestOfOfficials ?
    targets.slice(0, isMoreThanThreeOfficials ? 2 : 3) :
    targets;

  const renderOfficials = (officials: MatchedTargets) => officials.map(target => `${target.title || ''} ${target.firstName} ${target.lastName}`).join(', ');

  return (
    <GreetingText>
      {greeting}
      {' '}
      {!shownTargets.length ?
        'Official' :
        renderOfficials(shownTargets)
      }
      {!showRestOfOfficials && isMoreThanThreeOfficials && (
        <ShowMoreButton onClick={() => setShowRestOfOfficials(true)}>
          {`(and ${targets.length - 2} others)`}
        </ShowMoreButton>
      )}
      {(!isEmailAction || mode === 'petition') ? '.' : ','}
    </GreetingText>
  );
};
